import { Outlet } from "react-router-dom";
import PublicNav from "./PublicNav";
import PublicFooter from "./PublicFooter";
import WhatsAppFloat from "../WhatsAppFloat";

export default function PublicLayout() {
  return (
    <div className="theme-marketing min-h-screen flex flex-col">
      <PublicNav />
      <main className="flex-1 pt-20">
        <Outlet />
      </main>
      <PublicFooter />
      <WhatsAppFloat />
    </div>
  );
}
